import React from 'react';

import {
  Main,
  Heading,
  ContentGroup,
  Paragraph,
  List,
  ListItem,
  Strong,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { StyledLink } from 'client/components/styledLink/StyledLink';
import testIds from 'client/testIds';
import { Helmet } from 'react-helmet';

import { LimitedCompnayPageContent } from './LimitedCompanyPage.config';
import * as routes from '../../manifest';

export default function LimitedCompanyPage() {
  const {
    pageHeading,
    metaContent: { title },
    section1Heading,
    section1Text1,
    section1Text2,
    section1pargraphList,
    section2Heading,
    section2Text1,
    section2Text2,
    section3Heading,
    section3Text1,
    section3BoldList1,
    section3PargraphList1,
    section3BoldList2,
    section3PargraphList2,
    section3BoldList3,
    section4Heading,
    section4Text1,
    section4Text2,
    section4pargraphList,
  } = useContent<LimitedCompnayPageContent>();

  return (
    <Main>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ContentGroup marginTop="05">
        <StyledLink
          iconPosition="left"
          data-testid="back-button-link"
          to={routes.OurMortgages}
        >
          Back to Our mortgages
        </StyledLink>
      </ContentGroup>
      <Heading
        as="h1"
        size="s7"
        data-testid={testIds.limitedCompany.heading}
        marginTop="05"
      >
        {pageHeading}
      </Heading>
      <Heading
        size="s3"
        marginBottom="02"
        data-testid={`${testIds.limitedCompany.sectionHeading}-1`}
        as="h3"
      >
        {section1Heading}
      </Heading>
      <Paragraph>{section1Text1}</Paragraph>
      <Paragraph>{section1Text2}</Paragraph>
      <List>
        {section1pargraphList.map((item) => (
          <ListItem key={item}>{item}</ListItem>
        ))}
      </List>
      <Heading
        size="s3"
        marginBottom="02"
        data-testid={`${testIds.limitedCompany.sectionHeading}-2`}
        as="h3"
      >
        {section2Heading}
      </Heading>
      <Paragraph>{section2Text1}</Paragraph>
      <Paragraph>{section2Text2}</Paragraph>
      <Heading
        size="s3"
        marginBottom="02"
        data-testid={`${testIds.limitedCompany.sectionHeading}-3`}
        as="h3"
      >
        {section3Heading}
      </Heading>
      <Paragraph>{section3Text1}</Paragraph>

      <List marginBottom="05">
        {section3BoldList1.map(({ key, value }) => (
          <ListItem key={key}>
            <Strong>{key}</Strong>: {value}
          </ListItem>
        ))}
      </List>
      {section3PargraphList1.map((item) => (
        <Paragraph marginLeft="08" key={item}>
          {item}
        </Paragraph>
      ))}
      <List marginBottom="05">
        {section3BoldList2.map(({ key, value }) => (
          <ListItem key={key}>
            <Strong>{key}</Strong>: {value}
          </ListItem>
        ))}
      </List>
      {section3PargraphList2.map((item) => (
        <Paragraph marginLeft="08" key={item}>
          {item}
        </Paragraph>
      ))}
      <List>
        {section3BoldList3.map(({ key, value }) => (
          <ListItem key={key}>
            <Strong>{key}</Strong>: {value}
          </ListItem>
        ))}
      </List>
      <Heading
        size="s3"
        marginBottom="02"
        data-testid={`${testIds.limitedCompany.sectionHeading}-4`}
        as="h3"
      >
        {section4Heading}
      </Heading>
      <Paragraph>{section4Text1}</Paragraph>
      <Paragraph>{section4Text2}</Paragraph>
      <List>
        {section4pargraphList.map((value) => (
          <ListItem key={value}>{value}</ListItem>
        ))}
      </List>
    </Main>
  );
}
